import { join } from "path";

import { ConfigSubdomain } from "@/configuration/tenant-ids";

export const GROUPS_CONFIGURATION_DIR = join(process.cwd(), "configuration", "groups");
export const DEFAULT_CONFIGURATION_DIR = join(process.cwd(), "configuration", "default");
export const SANDBOX_SUBDOMAIN_SUFFIX = "-test";

const ROUTING_SUBDOMAIN_BY_SHARED_FOLDER: Record<string, ConfigSubdomain> = {
  demo: ConfigSubdomain.VALERIE,
};

export function getSharedConfigFolderFromSubdomain(subdomain: string): string {
  if (subdomain.endsWith(SANDBOX_SUBDOMAIN_SUFFIX)) {
    return subdomain.slice(0, -SANDBOX_SUBDOMAIN_SUFFIX.length);
  }

  return subdomain;
}

export function isSandboxSubdomain(subdomain: string): boolean {
  return subdomain.endsWith(SANDBOX_SUBDOMAIN_SUFFIX);
}

export function getGroupConfigSubdomain(group: { subdomain: string }): string {
  const folder = getSharedConfigFolderFromSubdomain(group.subdomain);

  return ROUTING_SUBDOMAIN_BY_SHARED_FOLDER[folder] ?? folder;
}
